import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useForceUpdate from 'use-force-update';
import { getUserWixId } from 'modules/user/utils';
import { POPUP } from 'utils/constants/popup';
import { INTERCOM_EVENTS } from 'modules/intercom/intercom';
import { useTranslation } from 'utils/modifiedTranslation';
import { getSurvey, setSurvey } from 'modules/survey/api';
import { useAlert } from 'components/Alert';
import Form from 'new-ui/Components/Form';
import { PopupTitle, PopupContent, PopupButton } from 'new-ui/Components/Popup';
import app from 'new-ui/app';
import { getFormattedDate } from 'functions/getFormattedDate';
import './NextAppointment.css';

const SURVEY_NAME = 'nextAppointment';

let renderKey = 1;

const dateFormatter = (date = new Date()) => moment(date).format('MM/DD/YYYY');

const NextAppointment = ({ closePopup, source }) => {
  const { showAlert, hideAlert } = useAlert();
  const { data: profile } = useSelector((state) => state.profile);
  const [form, setForm] = useState(false);
  const { t } = useTranslation();
  const userWixId = getUserWixId(profile);
  const update = useForceUpdate();

  useEffect(() => {
    const fetch = async () => {
      const r = await getSurvey(SURVEY_NAME, userWixId);
      const nextAppointment = r?.data?.answers[0]?.value || '';

      const formData = {
        inputs: {
          nextAppointment: {
            type: 'date',
            minDate: new Date(),
            default: 'MM/DD/YYYY',
            formatter: dateFormatter,
          },
        },
        data: {
          nextAppointment,
        },
      };

      setForm(formData);
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const send = async () => {
    const answers = [
      {
        surveyKey: 'general',
        key: 'nextAppointment',
        value: form.data.nextAppointment,
      },
    ];
    try {
      await setSurvey(SURVEY_NAME, answers, userWixId);
      app.updateUserConfiguration({
        lastNextAppointment: form.data.nextAppointment ? new Date().toISOString() : null,
      });
      if (source) app.intercom.sendEvent(INTERCOM_EVENTS.NEXT_APPOINTMENT.POPUP_SUCCESS, { source });
      app.intercom.update({
        user: app.user,
        data: {
          next_appointment_date: form.data.nextAppointment
            ? Math.floor(new Date(form.data.nextAppointment).getTime() / 1000)
            : null,
        },
      });
      app.updateUserConfiguration({ scanDate: form.data.nextAppointment, scanDateUpdateDate: getFormattedDate() });

      closePopup();
      showAlert({
        content: (
          <div>
            {form.data.nextAppointment ? t('next_appointment.your_next_appointment', {
              date: dateFormatter(form.data.nextAppointment),
            }) : t('next_appointment.no_next_appointment')}
            {' '}
            <span
              className="edit-button"
              onClick={() => {
                hideAlert();
                app.openPopup(POPUP.NEXT_APPOINTMENT);
              }}
            >
              {t('medical_profile.edit')}
            </span>
          </div>
        ),
      });
    } catch (e) {
      showAlert({ content: 'Oops, something was wrong with saving the data!' });
    }
  };

  const onChange = () => {
    renderKey += 1;
    update();
  };

  return (
    <div className="next-appointment">
      <PopupTitle title={t('next_appointment.title')} />
      <PopupContent>
        <div className="next-appointment-description">
          {t('next_appointment.description')}
        </div>
        {form ? <Form key={renderKey} form={form} onChange={onChange} popupMode /> : null}
      </PopupContent>
      <PopupButton isVisible={form?.data?.nextAppointment} title={t('share_with_doctor.send')} action={send} />
    </div>
  );
};

NextAppointment.propTypes = {
  closePopup: PropTypes.func.isRequired,
  source: PropTypes.string,
};

export default NextAppointment;
